import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=e0d5a938&scoped=true&"
import script from "./RecordList.vue?vue&type=script&lang=js&"
export * from "./RecordList.vue?vue&type=script&lang=js&"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=e0d5a938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d5a938",
  null
  
)

export default component.exports